import { render, staticRenderFns } from "./DZSVG3.vue?vue&type=template&id=d2020d70&scoped=true"
import script from "./DZSVG3.vue?vue&type=script&lang=js"
export * from "./DZSVG3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2020d70",
  null
  
)

export default component.exports